export default "__VITE_ASSET__BtzfP9hQ__"